// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_AtualizaUsuariosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /contas/atualiza_usuarios/{id}
 *
 * Echoes the conta_id whose user-permission links were rewritten.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contas_AtualizaUsuariosResponseDados {
conta_id: number
}

export type Contas_AtualizaUsuariosResponse = ApiResponse<Contas_AtualizaUsuariosResponseDados>;

registerResponseContract('Contas_AtualizaUsuariosResponse', {
  conta_id: { type: 'number',  required: true },
})
